export default "__VITE_ASSET__CTcnfFLC__"